type TokenGetter = () => Promise<string | null>;
type WorkspaceIdGetter = () => string | number | null;

let _tokenGetter: TokenGetter | null = null;
let _workspaceIdGetter: WorkspaceIdGetter | null = null;

export function setApiTokenGetter(getter: TokenGetter | null): void {
  _tokenGetter = getter;
}

/**
 * Multi-business workspaces (Task #616). When set, every imperative apiFetch
 * call attaches `X-Workspace-Id: <id>` so the server scopes the request to
 * the tab/session-active workspace. Server validates against the accessible
 * set; invalid values are ignored.
 */
export function setApiWorkspaceIdGetter(getter: WorkspaceIdGetter | null): void {
  _workspaceIdGetter = getter;
}

export async function apiFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const headers = new Headers(init?.headers);

  if (_tokenGetter && !headers.has("authorization")) {
    try {
      const token = await _tokenGetter();
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
    } catch {
      // Token refresh failed — proceed without Bearer header; cookie auth
      // (credentials: "include") will be used as fallback by the server.
    }
  }

  if (_workspaceIdGetter && !headers.has("x-workspace-id")) {
    const wid = _workspaceIdGetter();
    if (wid != null && String(wid).trim() !== "") {
      headers.set("x-workspace-id", String(wid));
    }
  }

  return fetch(input, {
    credentials: "include",
    ...init,
    headers,
  });
}
